import service1 from "../Assets/Images/services/Arthritis.jpg";
import service2 from "../Assets/Images/services/Migraine.jpg";
import service3 from "../Assets/Images/services/diabetics.jpg";
import service4 from "../Assets/Images/services/Skintreatment.jpg";
import service5 from "../Assets/Images/services/hairfall.JPG";
import service6 from "../Assets/Images/services/depression.JPG";
import service7 from "../Assets/Images/services/gas.JPG";
import service8 from "../Assets/Images/services/immunity.JPG";

export const serviceDetailsList = [
  {
    serviceName: "Arthritis",
    description:
      "We velayudha pharmacy and clinic offer a comprehensive approach to managing arthritis, focusing on both symptom relief and long-term health improvement. Our treatments are designed to address the underlying imbalances in the body that contribute to joint inflammation and discomfort.",
    image: service1
  },
  {
    serviceName: "Migraine & Sinusitis",
    description:
      "We Velayudha pharmacy and clinic,understand that migraines can be debilitating and disrupt daily life. Our holistic approach focuses on identifying the root cause of your migraines rather than just alleviating the symptoms",
    image: service2
  },
  {
    serviceName: "Diabetics",
    description:
      "We, Velayudha pharmacy and clinic,recognize that diabetics management requires a holistic approach that addresses both the physical and emotional aspects of health. Our goal is to help you achieve optimal blood sugar levels, improve overall well-being, and prevent complications associated with diabetes",
    image: service3
  },
  {
    serviceName: "Skin treatment",
    description:
      "We, Velayudha pharmacy and clinic,specialize in holistic skin treatments that aim to restore your skin's natural beauty and health from within. We believe that healthy skin reflects a balanced body and mind, and our approach focuses on identifying and addressing the root causes of skin issues rather than merely treating the symptoms.",
    image: service4
  },
  {
    serviceName: "Hair fall & Dandruf",
    description:
      "understand that hair fall and dandruff can be distressing issues that affect not only your appearance but also your self-esteem. Our holistic approach focuses on identifying the underlying causes of these conditions and promoting healthy hair growth and scalp health through natural remedies.",
    image: service5
  },
  {
    serviceName: "Depression & Anxiety",
    description:
      "We, Velayudha pharmacy and clinic,recognize that depression and anxiety can deeply impact your overall well-being and quality of life. Our holistic approach focuses on addressing the root causes of these conditions and restoring balance to the mind and body through natural and personalized treatments.",
    image: service6
  },
  {
    serviceName: "Gastric Problem",
    description:
      "We, Velayudha pharmacy and clinic,understand that gastric problems can significantly affect your quality of life. Our holistic approach aims to identify the root causes of these issues, such as indigestion, bloating, acidity, and gastritis, and restore balance to your digestive system through natural and effective treatments. ",
    image: service7
  },
  {
    serviceName: "Immunity booster Program",
    description:
      "We, Velayudha pharmacy and clinic,recognize that a robust immune system is essential for overall health and well-being. Our Immunity Booster Program is designed to enhance your body's natural defenses through a holistic approach that combines personalized treatments, lifestyle modifications, and dietary guidance.",
    image: service8
  }
];
